import { render, staticRenderFns } from "./PreviewHtml.vue?vue&type=template&id=2b8779c6&scoped=true&"
import script from "./PreviewHtml.vue?vue&type=script&lang=ts&"
export * from "./PreviewHtml.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewHtml.vue?vue&type=style&index=0&id=2b8779c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8779c6",
  null
  
)

export default component.exports